import { Injectable, inject } from '@angular/core';
import { CookieService, CookieSettings } from './cookie.service';
import { DateTime } from 'luxon';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ActivityTrackingService {
  //Used to detect idle and auto-logout

  private cookieService = inject(CookieService);

  private excludedUrls: string[] = [
    `${environment.identityServer.url}/connect/token`,
    `${environment.identityServer.url}/.well-known/openid-configuration/jwks`,
    `${environment.identityServer.url}/connect/userinfo`,
    `${environment.identityServer.url}/api/session-check`,
  ];

  trackActivity(url: string): void {
    if (this.shouldTrackActivity(url)) {
      const expires = DateTime.now().plus(
        environment.autoLogoutMinutes * 60 * 1000,
      );
      this.cookieService.setCookie({
        name: 'PortalAuthExpirationTicket',
        expires: expires,
        value: expires.toMillis().toString(),
        secure: true,
        session: true,
      } as CookieSettings);
    }
  }

  private shouldTrackActivity(url: string): boolean {
    return !this.excludedUrls.some((excludedUrl) => url.includes(excludedUrl));
  }
}
